import React, { useState } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import './SuperMarket.css';

function Hotel() {
  const [categories] = useState({
    
      "Food items": [

  { "name": "Idly", "price": 10 },
  { "name": "Medu Vada", "price": 25 },
  { "name": "Masala Dosa", "price": 60 },
  { "name": "Plain Dosa", "price": 50 },
  { "name": "Onion Uttapam", "price": 70 },
  { "name": "Rava Dosa", "price": 65 },
  { "name": "Pongal", "price": 55 },
  { "name": "Upma", "price": 45 },
  { "name": "Poha", "price": 35 },
  { "name": "Sabudana Khichdi", "price": 50 },
  { "name": "Aloo Paratha", "price": 60 },
  { "name": "Chole Bhature", "price": 75 },
  { "name": "Bread Omelette", "price": 55 },

  
  { "name": "Vada Curry", "price": 60 },
  { "name": "Poori", "price": 50 },
  { "name": "Chilli Chicken", "price": 120 },
  { "name": "Chilli Gobi", "price": 90 },
  { "name": "Chilli Mushroom", "price": 100 },
  { "name": "Chicken Drumsticks", "price": 150 },
  { "name": "Masala Vada", "price": 20 },
  { "name": "Millet Idly", "price": 40 },
  { "name": "Millet Dosa", "price": 45 },
  { "name": "Ragi Dosa", "price": 45 },
  { "name": "Sambar Vada", "price": 35 },
  { "name": "Mini Idly", "price": 30 },
  { "name": "Combo Tiffin 1", "price": 80 },
  { "name": "Combo Tiffin 2", "price": 85 },
  { "name": "Combo Lunch 1", "price": 130 },
  { "name": "Combo Lunch 2", "price": 140 },
  { "name": "Combo Dinner 1", "price": 130 },
  { "name": "Combo Dinner 2", "price": 140 },
  { "name": "Bhel Puri", "price": 50 },
  { "name": "Sev Puri", "price": 55 },
  { "name": "Dhai Puri", "price": 60 },
  { "name": "Dhai Masala", "price": 65 },
  { "name": "Cutlet", "price": 35 },
  { "name": "Vada", "price": 20 },
  { "name": "Papad Chat", "price": 45 },
  { "name": "Samosa Chat", "price": 50 },
  { "name": "Gobi Chat", "price": 55 },
  { "name": "Mix Chat", "price": 60 },
  { "name": "Paneer Chat", "price": 65 },
  { "name": "Mushroom Chat", "price": 65 },
  { "name": "Idli Vada", "price": 40 },
  { "name": "Karam Dosa", "price": 45 },
  { "name": "Ghee Karam Dosa", "price": 55 },
  { "name": "Egg Dosa", "price": 60 },
  { "name": "Egg Masala Dosa", "price": 70 },
  { "name": "Double Egg Dosa", "price": 75 },
  { "name": "Idli - Chicken Combo", "price": 85 },
  { "name": "Mutton Curry", "price": 130 },
  { "name": "Boti Curry", "price": 125 },
  { "name": "Fish Curry", "price": 120 },
  { "name": "Goat-head/Thala Curry", "price": 135 },
  { "name": "Paya", "price": 110 },
  { "name": "Parota", "price": 25 },
  { "name": "Gobi Fried Rice", "price": 90 },
  { "name": "Mushroom Fried Rice", "price": 95 },
  { "name": "Chicken Fried Rice", "price": 110 },
  { "name": "Mutton Fried Rice", "price": 130 },
  { "name": "Non-Veg Mixed Rice", "price": 135 },
  { "name": "Biriyani Combo 1", "price": 140 },
  { "name": "Biriyani Combo 2", "price": 150 },
  { "name": "Gobi Curry", "price": 90 },
  { "name": "Drumstick Curry", "price": 95 },
  { "name": "Brinjal Curry", "price": 90 },
  { "name": "Curd", "price": 20 },
  { "name": "Boiled Curry", "price": 80 },
  { "name": "Fried Curry", "price": 90 },
  { "name": "Veg Curry", "price": 85 },
  { "name": "Non Veg Curry", "price": 110 },


  { "name": "Rava Upma", "price": 45 },
  { "name": "Kesari Bath", "price": 50 },
  { "name": "Khara Bath", "price": 50 },
  { "name": "Set Dosa", "price": 55 },
  { "name": "Benne Dosa", "price": 60 },
  { "name": "Podi Dosa", "price": 65 },
  { "name": "Ghee Roast", "price": 70 },
  { "name": "Mysore Masala Dosa", "price": 75 },
  { "name": "Aval Upma", "price": 45 },
  { "name": "Idli Sambar Combo", "price": 50 },
  { "name": "Mini Tiffin", "price": 90 },
  { "name": "Uppittu with Coconut Chutney", "price": 40 },
  { "name": "Ragi Dosa", "price": 55 },
  { "name": "Akki Roti", "price": 60 },
  { "name": "Vermicelli Upma", "price": 50 },


  { "name": "Paneer Sandwich", "price": 65 },
  { "name": "Tea", "price": 15 },
  { "name": "Coffee", "price": 20 },
  { "name": "Filter Coffee", "price": 25 },
  { "name": "Banana Chips", "price": 30 },
  { "name": "Samosa", "price": 20 },
  { "name": "Kachori", "price": 25 },
  { "name": "Pakora", "price": 40 },
  { "name": "Vegetable Cutlet", "price": 45 },
  { "name": "Pani Puri", "price": 30 },
  { "name": "Sev Puri", "price": 40 },
  { "name": "Bhel Puri", "price": 35 },

  
  { "name": "Aloo Tikki Chaat", "price": 50 },
  { "name": "Dahi Puri", "price": 55 },
  { "name": "Raj Kachori", "price": 65 },
  { "name": "Papdi Chaat", "price": 50 },
  { "name": "Corn Chaat", "price": 60 },
  { "name": "Sprout Chaat", "price": 55 },
  { "name": "Chana Chaat", "price": 50 },
  { "name": "Fruit Chaat", "price": 60 },
  { "name": "Aloo Chaat", "price": 45 },
  { "name": "Dahi Bhalla", "price": 60 },
  { "name": "Stuffed Golgappa", "price": 40 },
  { "name": "Cheese Pani Puri", "price": 45 },
  { "name": "Mexican Chaat", "price": 70 },
  { "name": "Tandoori Aloo Chaat", "price": 75 },
  { "name": "Hariyali Chaat", "price": 55 },


  { "name": "Sambar Rice", "price": 70 },
  { "name": "Curd Rice", "price": 60 },
  { "name": "Lemon Rice", "price": 65 },
  { "name": "Tamarind Rice (Puliyodarai)", "price": 70 },
  { "name": "Tomato Rice", "price": 65 },
  { "name": "Bisi Bele Bath", "price": 80 },
  { "name": "Vegetable Kurma", "price": 85 },
  { "name": "Steamed Rice with Rasam", "price": 60 },
  { "name": "South Indian Meal (Mini)", "price": 110 },
  { "name": "South Indian Full Thali", "price": 150 },
  { "name": "Chow Chow Bath", "price": 90 },
  { "name": "Sundakkai Vatha Kuzhambu", "price": 80 },
  { "name": "Kara Kuzhambu", "price": 85 },
  { "name": "Avial", "price": 75 },
  { "name": "Moru Curry", "price": 70 },
  
  { "name": "Veg Thali", "price": 120 },
  { "name": "Dal Makhani", "price": 90 },
  { "name": "Rajma Chawal", "price": 85 },
  { "name": "Palak Paneer", "price": 95 },
  { "name": "Paneer Butter Masala", "price": 110 },
  { "name": "Mixed Veg Curry", "price": 80 },
  { "name": "Matar Mushroom", "price": 100 },
  { "name": "Chilli Paneer", "price": 95 },
  { "name": "Veg Biryani", "price": 100 },
  { "name": "Hyderabadi Biryani", "price": 130 },
  { "name": "Jeera Rice", "price": 60 },
  { "name": "Tandoori Roti", "price": 20 },
  { "name": "Butter Naan", "price": 25 },
  { "name": "Garlic Naan", "price": 30 },
  { "name": "Plain Paratha", "price": 20 },
  { "name": "Stuffed Paratha", "price": 40 },
  { "name": "Fried Rice", "price": 90 },
  { "name": "Hakka Noodles", "price": 85 },
  { "name": "Manchurian Gravy", "price": 80 },
  { "name": "Egg Curry", "price": 90 },
  { "name": "Chicken Curry", "price": 130 },
  { "name": "Mutton Rogan Josh", "price": 180 },
  { "name": "Fish Fry", "price": 150 },
  { "name": "Prawns Masala", "price": 160 },
  { "name": "Chicken Tikka", "price": 140 },


  
  { "name": "Spring Rolls", "price": 75 },
  { "name": "French Fries", "price": 60 },
  { "name": "Veg Burger", "price": 80 },
  { "name": "Paneer Burger", "price": 95 },
  { "name": "Chicken Burger", "price": 100 },
  { "name": "Veg Pizza", "price": 120 },
  { "name": "Cheese Corn Pizza", "price": 140 },
  { "name": "Chicken Pizza", "price": 160 },
  { "name": "Grilled Sandwich", "price": 70 },
  { "name": "Chocolate Shake", "price": 60 },
  { "name": "Cold Coffee", "price": 50 },
  { "name": "Lassi", "price": 45 },
  { "name": "Fresh Lime Soda", "price": 40 },
  { "name": "Ice Cream Cup", "price": 50 },
  { "name": "Falooda", "price": 80 },
  { "name": "Gulab Jamun", "price": 40 },
  { "name": "Rasgulla", "price": 35 },
  { "name": "Jilebi", "price": 30 },
  { "name": "Malpua", "price": 45 },
  { "name": "Kheer", "price": 50 },
  { "name": "Gajar Halwa", "price": 55 },
  { "name": "Milkshake (Strawberry)", "price": 65 },
  { "name": "Masala Lemonade", "price": 35 },
  { "name": "Fruit Salad", "price": 60 },
  { "name": "Chocolate Brownie", "price": 75 },


  { "name": "Payasam", "price": 60 },
  { "name": "Rava Kesari", "price": 55 },
  { "name": "Coconut Laddu", "price": 40 },
  { "name": "Mysore Rasayana", "price": 50 },
  { "name": "Madurai Jigarthanda", "price": 65 },
  
  { "name": "Modak", "price": 50 },
  { "name": "Mysore Pak", "price": 55 },
  { "name": "Kaju Katli", "price": 60 },
  { "name": "Basundi", "price": 65 },
  { "name": "Shrikhand", "price": 70 },
  { "name": "Sandesh", "price": 50 },
  { "name": "Petha", "price": 40 },
  { "name": "Chhena Poda", "price": 60 },
  { "name": "Kalakand", "price": 55 },
  { "name": "Rabri", "price": 65 },
  { "name": "Balushahi", "price": 45 },
  { "name": "Imarti", "price": 35 },
  { "name": "Boondi Ladoo", "price": 40 },
  { "name": "Coconut Burfi", "price": 30 },
  { "name": "Tilkut", "price": 35 },

  
  { "name": "Misal Pav", "price": 70 },
  { "name": "Vada Pav", "price": 40 },
  { "name": "Kothimbir Vadi", "price": 60 },
  { "name": "Thalipeeth", "price": 65 },
  { "name": "Litti Chokha", "price": 75 },
  { "name": "Dhokla", "price": 50 },
  { "name": "Khandvi", "price": 55 },
  { "name": "Undhiyu", "price": 100 },
  { "name": "Thepla", "price": 40 },
  { "name": "Methi Gota", "price": 45 },
  { "name": "Handvo", "price": 85 },
  { "name": "Sarson da Saag", "price": 90 },
  { "name": "Makki di Roti", "price": 25 },
  { "name": "Bajra Roti", "price": 20 },
  { "name": "Churma", "price": 50 },
  { "name": "Dal Baati", "price": 110 },
  { "name": "Khichdi", "price": 70 },
  { "name": "Pesarattu", "price": 60 },
  { "name": "Chettinad Chicken", "price": 140 },
  { "name": "Kerala Sadya (Mini)", "price": 180 },
  { "name": "Appam with Stew", "price": 100 },
  { "name": "Idiyappam", "price": 45 },
  { "name": "Malabar Parotta", "price": 30 },
  { "name": "Fish Molee", "price": 160 },
  { "name": "Bamboo Shoot Curry", "price": 90 },
  { "name": "Singju Salad", "price": 55 },
  { "name": "Smoked Pork", "price": 130 },
  { "name": "Naga Bamboo Chicken", "price": 140 },
  { "name": "Assamese Duck Curry", "price": 180 },
  { "name": "Pakhala Bhata", "price": 65 },
  { "name": "Ghugni", "price": 40 },
  { "name": "Shukto", "price": 80 },
  { "name": "Beguni", "price": 35 },
  { "name": "Chingri Malai Curry", "price": 160 },
  { "name": "Aloo Posto", "price": 75 },
  { "name": "Kosha Mangsho", "price": 150 },
  { "name": "Prawn Pollichathu", "price": 170 },
  { "name": "Chicken Ghee Roast", "price": 135 },
  { "name": "Neer Dosa", "price": 55 },
  { "name": "Sol Kadhi", "price": 30 },
  { "name": "Tambda Rassa", "price": 140 },
  { "name": "Pandhra Rassa", "price": 135 },
  { "name": "Zunka Bhakar", "price": 60 },
  { "name": "Gatte Ki Sabzi", "price": 70 },
  { "name": "Ker Sangri", "price": 85 },
  { "name": "Sattu Paratha", "price": 60 },
  { "name": "Bhutte Ka Kees", "price": 50 },
  { "name": "Paniyaram", "price": 45 },
  { "name": "Kozhukattai", "price": 40 },
  { "name": "Sundal", "price": 35 },

  
  { "name": "Kolkata Chicken Biryani", "price": 140 },
  { "name": "Lucknowi Biryani", "price": 135 },
  { "name": "Ambur Biryani", "price": 130 },
  { "name": "Thalassery Biryani", "price": 140 },
  { "name": "Dindigul Biryani", "price": 145 },
  { "name": "Sindhi Biryani", "price": 135 },
  { "name": "Mutton Biryani", "price": 160 },
  { "name": "Egg Biryani", "price": 120 },
  { "name": "Prawn Biryani", "price": 170 },
  { "name": "Crab Biryani", "price": 180 },
  { "name": "Fish Biryani", "price": 150 },
  { "name": "Paneer Biryani", "price": 125 },
  { "name": "Jackfruit Biryani", "price": 115 },
  { "name": "Hyderabadi Dum Biryani", "price": 150 },
  { "name": "Chicken 65 Biryani", "price": 160 },


  
  { "name": "Goan Prawn Curry", "price": 160 },
  { "name": "Fish Curry (Mangalorean)", "price": 150 },
  { "name": "Crab Masala", "price": 180 },
  { "name": "Squid Fry", "price": 140 },
  { "name": "Pomfret Tandoori", "price": 190 },
  { "name": "Grilled Salmon (Indian style)", "price": 200 },
  { "name": "Fish Tikka", "price": 160 },
  { "name": "Prawn Pepper Fry", "price": 170 },
  { "name": "Fish Pakora", "price": 130 },
  { "name": "Fish Fingers", "price": 120 },
  { "name": "Surmai Curry", "price": 165 },
  { "name": "Bangda Masala Fry", "price": 155 },
  { "name": "Kerala Fish Curry", "price": 150 },
  { "name": "Tandoori Prawns", "price": 175 },
  { "name": "Seafood Platter", "price": 250 },


  
  { "name": "Chicken 65", "price": 120 },
  { "name": "Chicken Lollipop", "price": 130 },
  { "name": "Tandoori Chicken", "price": 150 },
  { "name": "Butter Chicken", "price": 140 },
  { "name": "Chicken Korma", "price": 135 },
  { "name": "Chicken Chettinad", "price": 145 },
  { "name": "Mutton Korma", "price": 170 },
  { "name": "Bhuna Gosht", "price": 160 },
  { "name": "Chicken Keema", "price": 120 },
  { "name": "Egg Bhurji", "price": 80 },
  { "name": "Keema Paratha", "price": 85 },
  { "name": "Nalli Nihari", "price": 180 },
  { "name": "Murgh Musallam", "price": 190 },
  { "name": "Chicken Sukka", "price": 140 },
  { "name": "Lamb Chops", "price": 200 },


  
  { "name": "Ragi Mudde with Sambar", "price": 75 },
  { "name": "Millet Khichdi", "price": 80 },
  { "name": "Quinoa Upma", "price": 85 },
  { "name": "Multigrain Roti", "price": 25 },
  { "name": "Avocado Paratha", "price": 60 },
  { "name": "Grilled Tofu Salad", "price": 90 },
  { "name": "Sprouted Moong Bowl", "price": 75 },
  { "name": "Oats Idli", "price": 60 },
  { "name": "Brown Rice Pulao", "price": 90 },
  { "name": "Steamed Fish Fillet", "price": 150 },
  { "name": "Boiled Egg Sandwich", "price": 70 },
  { "name": "Mushroom Omelette", "price": 80 },
  { "name": "Wheat Dosa", "price": 50 },
  { "name": "Cabbage Rolls", "price": 85 },
  { "name": "Spinach Corn Stir Fry", "price": 75 },
  { "name": "Broccoli Cutlet", "price": 70 },
  { "name": "Oats Chilla", "price": 65 },
  { "name": "Vegetable Lettuce Wrap", "price": 80 },
  { "name": "Protein Salad Bowl", "price": 95 },
  { "name": "Boiled Chicken Salad", "price": 120 },
  { "name": "Low-fat Paneer Curry", "price": 100 },
  { "name": "Chickpea Wrap", "price": 90 },
  { "name": "Low-spice Dal Soup", "price": 60 },
  { "name": "Herbed Chicken Skewers", "price": 145 },
  { "name": "Baked Eggplant Chips", "price": 50 },

  { "name": "Chicken Shawarma", "price": 120 },
  { "name": "Mutton Seekh Kebab", "price": 160 },
  { "name": "Chicken Caesar Wrap", "price": 130 },
  { "name": "Peri Peri Chicken Wings", "price": 140 },
  { "name": "Egg Noodles", "price": 90 },
  { "name": "Chicken Pasta (Indian Tadka)", "price": 140 },
  { "name": "Spicy Chicken Enchiladas", "price": 160 },
  { "name": "Thai Chicken Curry", "price": 150 },
  { "name": "Honey Garlic Chicken", "price": 140 },
  { "name": "Grilled Chicken Steak", "price": 170 },
  { "name": "Egg Fried Rice", "price": 100 },
  { "name": "BBQ Chicken Pizza", "price": 160 },
  { "name": "Chicken Hot Dog", "price": 90 },
  { "name": "Chicken Meatballs", "price": 130 },
  { "name": "Egg Roll", "price": 80 },
  { "name": "Fish Steak", "price": 180 },
  { "name": "Spicy Chicken Ramen", "price": 140 },
  { "name": "Lamb Rogan Lasagna", "price": 185 },
  { "name": "Egg Curry with Coconut", "price": 100 },
  { "name": "Fish Tempura", "price": 150 },
  { "name": "Garlic Butter Prawns", "price": 170 },
  { "name": "Duck Roast (Kerala style)", "price": 190 },
  { "name": "Chicken Sizzler", "price": 175 },
  { "name": "Smoked Mutton Burger", "price": 150 },
  { "name": "Fish Taco (Indian twist)", "price": 145 },
  { "name": "Stuffed Capsicum", "price": 90 },
  { "name": "Tandoori Broccoli", "price": 85 },
  { "name": "Paneer Tikka", "price": 100 },
  { "name": "Corn Cheese Balls", "price": 80 },
  { "name": "Mushroom Masala", "price": 95 },
  { "name": "Baingan Bharta", "price": 70 },
  { "name": "Soya Chaap Gravy", "price": 90 },
  { "name": "Tofu Stir Fry", "price": 85 },
  { "name": "Paneer Lababdar", "price": 110 },
  { "name": "Dum Aloo Kashmiri", "price": 100 },
  { "name": "Rajma Masala", "price": 80 },
  { "name": "Lauki Kofta", "price": 85 },
  { "name": "Aloo Methi", "price": 70 },
  { "name": "Bhindi Masala", "price": 75 },
  { "name": "Karela Fry", "price": 65 },
  { "name": "Gobi Manchurian", "price": 90 },
  { "name": "Schezwan Fried Rice (Veg)", "price": 95 },
  { "name": "Cheese Burst Sandwich", "price": 70 },
  { "name": "Paneer Frankie", "price": 85 },
  { "name": "Veg Lasagna (Indian style)", "price": 120 },
  { "name": "Baked Vegetables in White Sauce", "price": 110 },
  { "name": "Zucchini Curry", "price": 90 },
  { "name": "Beetroot Cutlet", "price": 65 },
  { "name": "Hara Bhara Kabab", "price": 75 },
  { "name": "Sweet Corn Soup", "price": 60 },
    
                  ],

                  "Global renowed dishes and beverages": [

    
  { "name": "Sushi (Japan)", "price": 180 },
  { "name": "Tempura (Japan)", "price": 160 },
  { "name": "Ramen (Japan)", "price": 150 },
  { "name": "Bibimbap (Korea)", "price": 140 },
  { "name": "Kimchi Jjigae (Korea)", "price": 130 },
  { "name": "Sweet and Sour Pork (China)", "price": 145 },
  { "name": "Peking Duck (China)", "price": 200 },
  { "name": "Dim Sum (China)", "price": 180 },
  { "name": "Pho (Vietnam)", "price": 135 },
  { "name": "Banh Mi (Vietnam)", "price": 90 },
  { "name": "Pad Thai (Thailand)", "price": 140 },
  { "name": "Green Curry (Thailand)", "price": 135 },
  { "name": "Nasi Goreng (Indonesia)", "price": 125 },
  { "name": "Beef Rendang (Indonesia)", "price": 150 },
  { "name": "Hainanese Chicken Rice (Singapore)", "price": 130 },

  
  { "name": "Pizza Margherita (Italy)", "price": 160 },
  { "name": "Spaghetti Carbonara (Italy)", "price": 155 },
  { "name": "Lasagna (Italy)", "price": 170 },
  { "name": "Paella (Spain)", "price": 180 },
  { "name": "Tapas Assortment (Spain)", "price": 160 },
  { "name": "Croque Monsieur (France)", "price": 140 },
  { "name": "Coq au Vin (France)", "price": 190 },
  { "name": "Quiche Lorraine (France)", "price": 150 },
  { "name": "Beef Stroganoff (Russia)", "price": 170 },
  { "name": "Borscht (Russia)", "price": 120 },
  { "name": "Goulash (Hungary)", "price": 150 },
  { "name": "Pierogi (Poland)", "price": 110 },
  { "name": "Moussaka (Greece)", "price": 145 },
  { "name": "Baklava (Greece/Turkey)", "price": 90 },
  { "name": "Fish and Chips (UK)", "price": 150 },

  
  { "name": "Hamburger (USA)", "price": 130 },
  { "name": "Buffalo Wings (USA)", "price": 120 },
  { "name": "Mac and Cheese (USA)", "price": 115 },
  { "name": "New York Cheesecake (USA)", "price": 95 },
  { "name": "Tacos (Mexico)", "price": 110 },
  { "name": "Enchiladas (Mexico)", "price": 125 },
  { "name": "Guacamole Bowl (Mexico)", "price": 85 },
  { "name": "Ceviche (Peru)", "price": 140 },
  { "name": "Feijoada (Brazil)", "price": 160 },
  { "name": "Arepas (Venezuela)", "price": 90 },
  { "name": "Empanadas (Argentina)", "price": 100 },
  { "name": "Jerk Chicken (Jamaica)", "price": 135 },
  { "name": "Pabellón Criollo (Venezuela)", "price": 140 },
  { "name": "Tres Leches Cake (Central America)", "price": 95 },
  { "name": "Chimichurri Steak (Argentina)", "price": 180 },

  
  { "name": "Shawarma (Lebanon)", "price": 120 },
  { "name": "Hummus with Pita (Lebanon)", "price": 100 },
  { "name": "Falafel Wrap (Israel)", "price": 95 },
  { "name": "Manakish (Lebanon)", "price": 115 },
  { "name": "Kabsa (Saudi Arabia)", "price": 170 },
  { "name": "Zigni (Eritrea)", "price": 140 },
  { "name": "Tagine (Morocco)", "price": 150 },
  { "name": "Jollof Rice (Nigeria)", "price": 130 },
  { "name": "Bunny Chow (South Africa)", "price": 120 },
  { "name": "Suya Skewers (Nigeria)", "price": 135 },
  { "name": "Koshari (Egypt)", "price": 110 },
  { "name": "Injera with Wat (Ethiopia)", "price": 150 },
  { "name": "Harira Soup (Morocco)", "price": 100 },
  { "name": "Fattoush Salad (Jordan)", "price": 95 },
  { "name": "Mulukhiyah (Egypt)", "price": 125 },

  
  { "name": "Tiramisu (Italy)", "price": 100 },
  { "name": "Crème Brûlée (France)", "price": 110 },
  { "name": "Churros with Chocolate (Spain)", "price": 95 },
  { "name": "Dulce de Leche Ice Cream (Argentina)", "price": 100 },
  { "name": "Matcha Ice Cream (Japan)", "price": 90 },


  
  { "name": "Aguas Frescas (Mexico)", "price": 60 },
  { "name": "Mango Lassi (India)", "price": 70 },
  { "name": "Masala Chai (India)", "price": 50 },
  { "name": "Hōjicha (Japan)", "price": 80 },
  { "name": "Thai Iced Tea (Thailand)", "price": 90 },

  { "name": "Lulada (Colombia)", "price": 85 },
  { "name": "Maghrebi Mint Tea (Morocco)", "price": 75 },
  { "name": "Salep (Turkey)", "price": 95 },
  { "name": "Chocolate Caliente (Spain)", "price": 100 },
  { "name": "Café Cubano (Cuba)", "price": 90 },

  { "name": "Longjing Tea (China)", "price": 120 },
  { "name": "Colada Morada (Ecuador)", "price": 100 },
  { "name": "Horchata (Mexico)", "price": 70 },
  { "name": "Sweet Lassi (India)", "price": 65 },
  { "name": "Guarapo (Latin America)", "price": 60 },

  { "name": "Espresso Freddo (Italy)", "price": 90 },
  { "name": "Papelón con Limón (Venezuela)", "price": 70 },
  { "name": "Hong Kong Milk Tea", "price": 85 },
  { "name": "Teh Tarik (Malaysia)", "price": 80 },
  { "name": "Cholado (Colombia)", "price": 95 },

  { "name": "Turkish Coffee (Turkey)", "price": 100 },
  { "name": "Ristretto (Italy)", "price": 90 },
  { "name": "Frappé Coffee (Greece)", "price": 85 },
  { "name": "Pu Erh Tea (China)", "price": 110 },
  { "name": "Darjeeling Tea (India)", "price": 100 },

  { "name": "Vietnamese Iced Coffee", "price": 90 },
  { "name": "Leche con Plátano (Latin America)", "price": 70 },
  { "name": "Ponche Navideño (Mexico)", "price": 100 },
  { "name": "Chilate (El Salvador)", "price": 80 },
  { "name": "Green Tea (Japan)", "price": 85 },

  { "name": "Oolong Tea (Taiwan)", "price": 95 },
  { "name": "Flat White (Australia)", "price": 100 },
  { "name": "Sikhye (South Korea)", "price": 90 },
  { "name": "Kvass (Russia)", "price": 85 },
  { "name": "Karkade (Egypt)", "price": 80 },

  { "name": "Mate (Argentina)", "price": 75 },
  { "name": "Root Beer (USA)", "price": 70 },
  { "name": "Maple Sap Drink (Canada)", "price": 65 },
  { "name": "Lemon Myrtle Tea (Australia)", "price": 90 },
  { "name": "Kava (Fiji)", "price": 100 },

  { "name": "Bandung (Singapore)", "price": 85 },
  { "name": "Zobo (Nigeria)", "price": 80 },
  { "name": "Soda Chanh (Vietnam)", "price": 70 },
  { "name": "Champús (Peru)", "price": 90 },
  { "name": "Caffe Shakerato (Italy)", "price": 95 },

  { "name": "Ceylon Black Tea (Sri Lanka)", "price": 100 },
  { "name": "Indian Filter Coffee", "price": 60 },
  { "name": "Licuado (Mexico)", "price": 75 },
  { "name": "Freddo Cappuccino (Greece)", "price": 90 },
  { "name": "Rooibos Tea (South Africa)", "price": 85 },

  { "name": "Kombucha (USA)", "price": 120 },
  { "name": "Yerba Mate Latte (Argentina)", "price": 100 },
  { "name": "Bubble Tea (Taiwan)", "price": 90 },
  { "name": "Falooda (India)", "price": 95 },
  { "name": "Tamarind Juice (Middle East)", "price": 80 },

  { "name": "Coconut Water (Global Tropics)", "price": 60 },
  { "name": "Sugarcane Juice (India)", "price": 50 },
  { "name": "Aloe Vera Juice (Asia)", "price": 70 },
  { "name": "Barley Water (UK)", "price": 65 },
  { "name": "Sattu Drink (India)", "price": 55 },

  { "name": "Mulled Apple Cider (USA)", "price": 100 },
  { "name": "Hot Chocolate (France)", "price": 90 },
  { "name": "Turmeric Latte (India)", "price": 85 },
  { "name": "Kesar Doodh (India)", "price": 80 },
  { "name": "Mint Lemonade (Middle East)", "price": 75 },

  { "name": "Virgin Mojito (Global)", "price": 90 },
  { "name": "Virgin Mary (Global)", "price": 95 },
  { "name": "Peach Iced Sparkler (USA)", "price": 85 },
  { "name": "Berry Blast Cooler (UK)", "price": 90 },
  { "name": "Sparkling Apple Cider (USA)", "price": 100 },
                  ],
                  "Beverages": [

    
  { "name": "Bisleri Mineral Water", "price": 20 },
  { "name": "Kinley Water", "price": 20 },
  { "name": "Aquafina", "price": 20 },
  { "name": "Himalayan Premium Water", "price": 30 },
  { "name": "Evocus Alkaline Black Water", "price": 100 },
  
  { "name": "Real Mixed Fruit Juice", "price": 30 },
  { "name": "Tropicana Orange Juice", "price": 35 },
  { "name": "Paper Boat Aamras", "price": 30 },
  { "name": "B Natural Pomegranate Juice", "price": 40 },
  { "name": "Minute Maid Pulpy Orange", "price": 25 },

  
  { "name": "Frooti", "price": 20 },
  { "name": "Slice Mango Drink", "price": 25 },
  { "name": "Appy Fizz", "price": 30 },
  { "name": "Paper Boat Jaljeera", "price": 25 },
  { "name": "Coolberg Mint Mojito (non-alcoholic)", "price": 35 },


  
  { "name": "Coca-Cola/ coke", "price": 35 },
  { "name": "Pepsi", "price": 35 },
  { "name": "Thums Up", "price": 35 },
  { "name": "Sprite", "price": 35 },
  { "name": "Mountain Dew", "price": 35 },
  { "name": "Maaza", "price": 35 },
  { "name": "Fanta", "price": 35 },
  { "name": "Soda", "price": 35 },

  
  { "name": "Lipton Iced Tea (Peach)", "price": 30 },
  { "name": "Nestea Lemon Iced Tea", "price": 30 },
  { "name": "Paper Boat Tulsi Tea", "price": 25 },
  { "name": "Chaayos Masala Chai Bottle", "price": 40 },
  { "name": "Tea City Elaichi Chai", "price": 25 },

  
  { "name": "Bru Cold Coffee", "price": 35 },
  { "name": "Nescafé Iced Latte", "price": 40 },
  { "name": "Sleepy Owl Cold Brew", "price": 60 },
  { "name": "Blue Tokai Canned Cold Brew", "price": 75 },
  { "name": "Country Bean Hazelnut Brew", "price": 70 },

  
  { "name": "Red Bull", "price": 100 },
  { "name": "Monster Energy", "price": 120 },
  { "name": "Sting Energy Drink", "price": 50 },
  { "name": "Cloud 9", "price": 90 },
  { "name": "Gatorade Orange", "price": 50 },

  
  { "name": "Horlicks Classic Malt", "price": 180 },
  { "name": "Boost", "price": 170 },
  { "name": "Bournvita", "price": 180 },
  { "name": "Complan", "price": 200 },
  { "name": "Ensure Nutrition Drink", "price": 500 },


  
  { "name": "Amul Kool Kesar", "price": 25 },
  { "name": "Mother Dairy Flavored Milk", "price": 25 },
  { "name": "Verka Badam Milk", "price": 30 },
  { "name": "Nandini Chocolate Milk", "price": 30 },
  { "name": "Milky Mist Banana Milk", "price": 35 },


  
  { "name": "Coolberg Cranberry (non-alcoholic)", "price": 35 },
  { "name": "Sipwise Virgin Colada", "price": 40 },
  { "name": "Iceberg Mojito Mix", "price": 45 },
  { "name": "Sociowash Apple Punch", "price": 50 },
  { "name": "Beveragewala Citrus Crush", "price": 50 },

  
  { "name": "Neer Mor (South India)", "price": 25 },
  { "name": "Sol Kadhi (Konkan)", "price": 30 },
  { "name": "Bel Sharbat (North India)", "price": 35 },
  { "name": "Kokum Juice", "price": 35 },
  { "name": "Sugarcane Juice", "price": 20 },

  
  { "name": "Falooda Drink", "price": 60 },
  { "name": "Rose Milk", "price": 45 },
  { "name": "Badam Milkshake", "price": 50 },
  { "name": "Kesar Pista Shake", "price": 55 },
  { "name": "Kulfi Shake", "price": 60 },


  
  { "name": "Vedica Himalayan Water", "price": 40 },
  { "name": "Qua Natural Mineral Water", "price": 35 },
  { "name": "Aava Alkaline Water", "price": 50 },
  { "name": "Veen Still Water", "price": 90 },
  { "name": "Perrier Sparkling Water", "price": 120 },
  
  { "name": "Raw Pressery Pineapple Juice", "price": 80 },
  { "name": "Second Nature Cold Pressed Apple", "price": 85 },
  { "name": "Nutricane Sugarcane Juice", "price": 60 },
  { "name": "Juice Up Beetroot Blend", "price": 70 },
  { "name": "Fresh Pressery Green Juice", "price": 90 },
  
  { "name": "Xotik Jeeru", "price": 20 },
  { "name": "Bailley Mango Drink", "price": 25 },
  { "name": "Frutnik Litchi", "price": 30 },
  { "name": "Campa Litchi", "price": 25 },
  { "name": "Frubite Guava", "price": 30 },
  
  { "name": "RC Cola", "price": 30 },
  { "name": "Campa Cola", "price": 30 },
  { "name": "Big Cola", "price": 25 },
  { "name": "Zingo", "price": 25 },
  { "name": "Boomer Cola", "price": 20 },
  
  { "name": "TGL Co. Peach Tea", "price": 60 },
  { "name": "Tea Trunk Hibiscus Iced Tea", "price": 75 },
  { "name": "Vahdam Iced Green Tea", "price": 80 },
  { "name": "Brewhouse Lemon Iced Tea", "price": 50 },
  { "name": "Chai Point Ginger Chai", "price": 45 },
  
  { "name": "Starbucks Bottled Frappuccino", "price": 150 },
  { "name": "Bonhomia Cold Brew", "price": 90 },
  { "name": "Rage Coffee Ready-to-Drink", "price": 85 },
  { "name": "Slay Coffee Mocha", "price": 70 },
  { "name": "Third Wave Nitro Brew", "price": 100 },
  
  { "name": "Tzinga", "price": 30 },
  { "name": "Rebound Energy", "price": 40 },
  { "name": "Gold Rush", "price": 45 },
  { "name": "Proathlix Energy", "price": 60 },
  { "name": "Enerzal", "price": 50 },
  
  { "name": "Patanjali Aloe Vera Juice", "price": 60 },
  { "name": "Dabur Amla Juice", "price": 55 },
  { "name": "Kapiva Wheatgrass Juice", "price": 70 },
  { "name": "Zandu Giloy Juice", "price": 65 },
  { "name": "Sri Sri Tattva Triphala Juice", "price": 60 },
  
  { "name": "So Good Almond Milk", "price": 120 },
  { "name": "Raw Pressery Oat Milk", "price": 150 },
  { "name": "Urban Platter Soy Milk", "price": 110 },
  { "name": "Only Earth Coconut Milk", "price": 130 },
  { "name": "Alt Co. Vegan Milk", "price": 140 },
  
  { "name": "Svami Cucumber Tonic", "price": 80 },
  { "name": "Sepoy & Co. Mint Tonic", "price": 85 },
  { "name": "Jimmy’s Cocktails Cosmopolitan", "price": 90 },
  { "name": "Bartisans Mojito Mixer", "price": 95 },
  { "name": "Sippin’ Sangria Mix", "price": 100 },
  
  { "name": "Mountain Bee Kombucha", "price": 120 },
  { "name": "Happy Ratio Complete Drink", "price": 150 },
  { "name": "Buddha’s Brew Kombucha", "price": 130 },
  { "name": "Wellbeing Nutrition Probiotic Drink", "price": 140 },
  { "name": "Tea Culture of India Kombucha", "price": 125 },
  
  { "name": "Frozen Bottle Oreo Shake", "price": 120 },
  { "name": "Keventers Strawberry Milkshake", "price": 110 },
  { "name": "The Belgian Waffle Co. Nutella Shake", "price": 130 },
  { "name": "Drunken Monkey Choco Banana Shake", "price": 115 },
  { "name": "Lassi Shop Dry Fruit Lassi", "price": 90 },

  
  { "name": "Amul Kool Rose", "price": 25 },
  { "name": "Mother Dairy Lassi", "price": 30 },
  { "name": "Verka Mango Milkshake", "price": 35 },
  { "name": "Milky Mist Coffee Milk", "price": 30 },
  { "name": "Nandini Badam Milk", "price": 30 },

  { "name": "Paper Boat Panakam", "price": 25 },
  { "name": "Paper Boat Kokum", "price": 25 },
  { "name": "Paper Boat Sattu", "price": 25 },
  { "name": "Paper Boat Thandai", "price": 30 },
  { "name": "Paper Boat Chhaas", "price": 25 },

  { "name": "Raw Pressery Charcoal Lemonade", "price": 90 },
  { "name": "Second Nature Cold Pressed Pomegranate", "price": 85 },
  { "name": "Fresh Pressery Activated Charcoal", "price": 95 },
  { "name": "Nutricane Mosambi Juice", "price": 60 },
  { "name": "Juice Up Carrot Ginger", "price": 70 },

  { "name": "Kapiva A2 Ghee Shot", "price": 60 },
  { "name": "Zandu Neem Juice", "price": 65 },
  { "name": "Sri Sri Tattva Aloe Vera Juice", "price": 60 },
  { "name": "Patanjali Giloy Tulsi Juice", "price": 55 },
  { "name": "Dabur Brahmi Juice", "price": 60 },

  { "name": "So Good Cashew Milk", "price": 130 },
  { "name": "Only Earth Oat Milk", "price": 140 },
  { "name": "Alt Co. Rice Milk", "price": 135 },
  { "name": "Urban Platter Hemp Milk", "price": 150 },
  { "name": "Raw Pressery Almond Cocoa Milk", "price": 160 },

  { "name": "Brewhouse Peach Iced Tea", "price": 50 },
  { "name": "Chai Point Elaichi Chai", "price": 45 },
  { "name": "Tea Trunk Rose Iced Tea", "price": 75 },
  { "name": "Vahdam Turmeric Iced Tea", "price": 80 },
  { "name": "TGL Co. Lemongrass Tea", "price": 60 },

  { "name": "Slay Coffee Vanilla Cold Brew", "price": 70 },
  { "name": "Sleepy Owl Hazelnut Brew", "price": 65 },
  { "name": "Rage Coffee Mint Mocha", "price": 85 },
  { "name": "Third Wave Classic Cold Brew", "price": 100 },
  { "name": "Bonhomia Espresso Shot", "price": 90 },

  { "name": "Enerzal Orange", "price": 50 },
  { "name": "Proathlix Hydration Drink", "price": 60 },
  { "name": "Gold Rush Citrus", "price": 45 },
  { "name": "Rebound Electrolyte Drink", "price": 40 },
  { "name": "Tzinga Lemon Mint", "price": 30 },

  { "name": "Happy Ratio Daily Nutrition", "price": 150 },
  { "name": "Wellbeing Nutrition Melts", "price": 140 },
  { "name": "Tea Culture Kombucha Berry", "price": 125 },
  { "name": "Mountain Bee Kombucha Mint", "price": 120 },
  { "name": "Buddha’s Brew Kombucha Hibiscus", "price": 130 },

  { "name": "Frozen Bottle KitKat Shake", "price": 120 },
  { "name": "Keventers Butterscotch Milkshake", "price": 110 },
  { "name": "Drunken Monkey Avocado Shake", "price": 115 },
  { "name": "The Belgian Waffle Co. Coffee Shake", "price": 130 },
  { "name": "Lassi Shop Mango Lassi", "price": 90 },

  { "name": "Coolberg Peach (non-alcoholic)", "price": 35 },
  { "name": "Sipwise Virgin Mojito", "price": 40 },
  { "name": "Bartisans Watermelon Mixer", "price": 95 },
  { "name": "Jimmy’s Cocktails Margarita (non-alcoholic)", "price": 90 },
  { "name": "Sippin’ Berry Cooler", "price": 100 },

                  ],
                  "Room/Suite types": [

    
  { "name": "Standard Single Room", "price": 1200 },
  { "name": "Standard Double Room", "price": 1500 },
  { "name": "Twin Room", "price": 1600 },
  { "name": "Queen Room", "price": 1800 },
  { "name": "King Room", "price": 2000 },

  { "name": "Deluxe Room", "price": 2500 },
  { "name": "Super Deluxe Room", "price": 3000 },
  { "name": "Executive Room", "price": 3500 },
  { "name": "Premium Room", "price": 4000 },
  { "name": "Luxury Room", "price": 4500 },

  { "name": "Junior Suite", "price": 5000 },
  { "name": "Executive Suite", "price": 6000 },
  { "name": "Club Suite", "price": 6500 },
  { "name": "Presidential Suite", "price": 15000 },
  { "name": "Royal Suite", "price": 18000 },

  { "name": "Studio Room", "price": 2800 },
  { "name": "Studio Suite", "price": 3200 },
  { "name": "Family Room", "price": 3500 },
  { "name": "Triple Room", "price": 3000 },
  { "name": "Quad Room", "price": 4000 },

  { "name": "Connecting Room", "price": 4200 },
  { "name": "Adjoining Room", "price": 4100 },
  { "name": "Adjacent Room", "price": 4000 },
  { "name": "Accessible Room", "price": 3800 },
  { "name": "Smoking Room", "price": 3500 },

  { "name": "Non-Smoking Room", "price": 3500 },
  { "name": "Cabana Room", "price": 5000 },
  { "name": "Villa Room", "price": 8000 },
  { "name": "Cottage Room", "price": 6000 },
  { "name": "Tent Room", "price": 3000 },

  { "name": "Treehouse Room", "price": 7000 },
  { "name": "Heritage Room", "price": 5500 },
  { "name": "Boutique Room", "price": 4800 },
  { "name": "Eco Room", "price": 3500 },
  { "name": "Business Room", "price": 4000 },

  { "name": "Serviced Apartment", "price": 6000 },
  { "name": "Penthouse Suite", "price": 20000 },
  { "name": "Luxury Tent", "price": 7500 },
  { "name": "Pool View Room", "price": 5000 },
  { "name": "Sea View Room", "price": 5500 },

  { "name": "Mountain View Room", "price": 5200 },
  { "name": "Garden View Room", "price": 4800 },
  { "name": "City View Room", "price": 4500 },
  { "name": "Skyline View Room", "price": 4700 },
  { "name": "Balcony Room", "price": 4900 },

  { "name": "Terrace Room", "price": 5100 },
  { "name": "Jacuzzi Room", "price": 6000 },
  { "name": "Spa Suite", "price": 7000 },
  { "name": "Honeymoon Suite", "price": 8000 },
  { "name": "Bridal Suite", "price": 8500 },

  { "name": "Pet-Friendly Room", "price": 4000 },
  { "name": "Female Executive Room", "price": 4200 },
  { "name": "Male Executive Room", "price": 4200 },
  { "name": "Accessible Suite", "price": 5000 },
  { "name": "Luxury Business Suite", "price": 9000 },

  { "name": "Budget Room", "price": 1000 },
  { "name": "Economy Room", "price": 1200 },
  { "name": "Compact Room", "price": 1100 },
  { "name": "Mini Suite", "price": 3000 },
  { "name": "Murphy Room", "price": 2500 },

  { "name": "Extended Stay Room", "price": 5500 },
  { "name": "Studio Apartment", "price": 6000 },
  { "name": "Loft Room", "price": 5800 },
  { "name": "Bunk Bed Room", "price": 1500 },
  { "name": "Dormitory Room", "price": 800 },

                  ],
                  "Ultra-Expensive Room types": [

    
  { "name": "Sky Villa Suite", "price": 250000 },
  { "name": "Royal Penthouse Suite", "price": 200000 },
  { "name": "Ty Warner Penthouse", "price": 150000 },
  { "name": "Hilltop Villa", "price": 140000 },
  { "name": "The Empathy Suite", "price": 100000 },

  { "name": "Shahi Mahal Suite", "price": 28000 },
  { "name": "Maharajah’s Pavilion", "price": 29000 },
  { "name": "Kohinoor Suite", "price": 7500 },
  { "name": "Nizam Suite", "price": 7500 },
  { "name": "Sukh Niwas Suite", "price": 10000 },

  { "name": "Imperial Suite", "price": 12000 },
  { "name": "Royal Suite", "price": 18000 },
  { "name": "Manor House Suite", "price": 12600 },
  { "name": "Villa La Cupola", "price": 14280 },
  { "name": "Royal Armleder Suite", "price": 14556 },

  { "name": "Bridge Suite", "price": 15685 },
  { "name": "Champagne Suite", "price": 15895 },
  { "name": "Jewel Suite", "price": 15895 },
  { "name": "Presidential Suite", "price": 15000 },
  { "name": "Grand Riad", "price": 12000 },

  { "name": "Royal Residence", "price": 11000 },
  { "name": "Palace Suite", "price": 9500 },
  { "name": "Rajputana Suite", "price": 8500 },
  { "name": "Heritage Haveli Suite", "price": 8000 },
  { "name": "Lake Palace Suite", "price": 9000 },

  { "name": "Overwater Bungalow", "price": 7500 },
  { "name": "Private Island Villa", "price": 20000 },
  { "name": "Safari Lodge Suite", "price": 8500 },
  { "name": "Ice Hotel Deluxe Suite", "price": 7000 },
  { "name": "Underwater Suite", "price": 15000 },

  { "name": "Panoramic View Suite", "price": 9500 },
  { "name": "Infinity Pool Villa", "price": 10000 },
  { "name": "Clifftop Retreat", "price": 12000 },
  { "name": "Desert Palace Suite", "price": 8500 },
  { "name": "Rainforest Canopy Villa", "price": 8000 },

  { "name": "Art Deco Suite", "price": 7500 },
  { "name": "Oriental Pavilion", "price": 7800 },
  { "name": "Zen Garden Suite", "price": 7200 },
  { "name": "Royal Safari Tent", "price": 6800 },
  { "name": "Floating Villa", "price": 9500 },

  { "name": "Crystal Lagoon Suite", "price": 8800 },
  { "name": "Sunset Boulevard Suite", "price": 9200 },
  { "name": "Hollywood Glamour Suite", "price": 9800 },
  { "name": "Versace Signature Suite", "price": 10500 },
  { "name": "Mughal Courtyard Suite", "price": 8700 },

  { "name": "Private Spa Retreat", "price": 11000 },
  { "name": "Wellness Sanctuary Suite", "price": 9500 },
  { "name": "Royal Observatory Suite", "price": 10200 },
  { "name": "Oceanfront Pavilion", "price": 9800 },
  { "name": "Mountain Majesty Suite", "price": 9400 },

  { "name": "Garden Palace Suite", "price": 8900 },
  { "name": "Tropical Estate Villa", "price": 9700 },
  { "name": "Sunken Living Room Suite", "price": 9100 },
  { "name": "Glass Dome Suite", "price": 9900 },
  { "name": "Royal Hammam Suite", "price": 10800 },

  { "name": "Designer Loft Suite", "price": 8600 },
  { "name": "Vintage Chateau Room", "price": 9300 },
  { "name": "Royal Yacht Cabin", "price": 12000 },
  { "name": "Luxury Train Presidential Cabin", "price": 11500 },
  { "name": "Palatial Tent Suite", "price": 8800 },

  { "name": "Skyline Infinity Suite", "price": 10200 },
  { "name": "Royal Garden Terrace Suite", "price": 9700 },
  { "name": "Maharani’s Retreat", "price": 9400 },
  { "name": "Celestial Dome Suite", "price": 9900 },
  { "name": "Royal Fountain View Suite", "price": 9300 },

  { "name": "Sunrise Cliff Villa", "price": 9600 },
  { "name": "Royal Mirror Suite", "price": 9800 },
  { "name": "Luxury Cave Suite", "price": 8700 },
  { "name": "Royal Lantern Suite", "price": 9100 },
  { "name": "Golden Pavilion Suite", "price": 10500 },

                  ],
                  "Other Services": [

    { "name": "Other Service", "price": 500 },
    
  { "name": "Room Service", "price": 0 },
  { "name": "Housekeeping", "price": 0 },
  { "name": "Concierge Service", "price": 0 },
  { "name": "Laundry Service", "price": 300 },
  { "name": "Dry Cleaning", "price": 400 },

  { "name": "Valet Parking", "price": 200 },
  { "name": "Airport Shuttle", "price": 500 },
  { "name": "Wake-Up Call", "price": 0 },
  { "name": "Luggage Assistance", "price": 0 },
  { "name": "Bell Desk Service", "price": 0 },

  { "name": "Doctor on Call", "price": 0 },
  { "name": "First Aid Kit", "price": 0 },
  { "name": "Currency Exchange", "price": 0 },
  { "name": "Travel Desk", "price": 0 },
  { "name": "Tour Booking", "price": 0 },

  { "name": "Restaurant Service", "price": 0 },
  { "name": "Bar Service", "price": 0 },
  { "name": "Buffet Breakfast", "price": 350 },
  { "name": "In-Room Dining", "price": 0 },
  { "name": "Mini Bar", "price": 0 },

  { "name": "Spa Services", "price": 1500 },
  { "name": "Massage Therapy", "price": 1200 },
  { "name": "Salon Services", "price": 800 },
  { "name": "Steam Room", "price": 500 },
  { "name": "Sauna", "price": 500 },

  { "name": "Swimming Pool Access", "price": 0 },
  { "name": "Fitness Center", "price": 0 },
  { "name": "Yoga Classes", "price": 600 },
  { "name": "Personal Trainer", "price": 1000 },
  { "name": "Recreational Activities", "price": 0 },

  { "name": "Conference Room Rental", "price": 3000 },
  { "name": "Business Center", "price": 0 },
  { "name": "Printing Services", "price": 50 },
  { "name": "Fax Services", "price": 50 },
  { "name": "Photocopy Services", "price": 50 },

  { "name": "Wi-Fi Internet", "price": 0 },
  { "name": "Cable TV", "price": 0 },
  { "name": "Smart TV Access", "price": 0 },
  { "name": "USB Charging Ports", "price": 0 },
  { "name": "Power Backup", "price": 0 },

  { "name": "24x7 Reception", "price": 0 },
  { "name": "Express Check-In", "price": 0 },
  { "name": "Express Check-Out", "price": 0 },
  { "name": "Late Check-Out", "price": 500 },
  { "name": "Early Check-In", "price": 500 },

  { "name": "Pet-Friendly Services", "price": 800 },
  { "name": "Childcare/Babysitting", "price": 1000 },
  { "name": "Kids Play Area", "price": 0 },
  { "name": "Game Room", "price": 0 },
  { "name": "Library Access", "price": 0 },

  { "name": "Gift Shop", "price": 0 },
  { "name": "Souvenir Store", "price": 0 },
  { "name": "Florist Service", "price": 300 },
  { "name": "Tailoring Service", "price": 500 },
  { "name": "Shoe Shine Service", "price": 100 },

  { "name": "Ironing Service", "price": 200 },
  { "name": "Clothing Repair", "price": 300 },
  { "name": "Safety Deposit Box", "price": 0 },
  { "name": "Left Luggage Facility", "price": 0 },
  { "name": "Mailing & Courier Service", "price": 150 },

  { "name": "Newspaper Delivery", "price": 0 },
  { "name": "Complimentary Bottled Water", "price": 0 },
  { "name": "Tea/Coffee Maker", "price": 0 },
  { "name": "Welcome Drink", "price": 0 },
  { "name": "Fruit Basket", "price": 250 },


  
  { "name": "Butler Service", "price": 0 },
  { "name": "Private Chef", "price": 3000 },
  { "name": "In-Room Spa Treatment", "price": 2000 },
  { "name": "Turndown Service", "price": 0 },
  { "name": "Pillow Menu", "price": 0 },

  { "name": "Complimentary Breakfast", "price": 0 },
  { "name": "Afternoon Tea Service", "price": 500 },
  { "name": "Evening Snacks", "price": 300 },
  { "name": "Welcome Amenities", "price": 0 },
  { "name": "In-Room Barista", "price": 1000 },

  { "name": "Digital Room Key", "price": 0 },
  { "name": "Smart Room Controls", "price": 0 },
  { "name": "Voice-Activated Concierge", "price": 0 },
  { "name": "Tablet Entertainment Hub", "price": 0 },
  { "name": "Virtual Tour Booking", "price": 0 },

  { "name": "Private Cabana Rental", "price": 2500 },
  { "name": "Beach Butler Service", "price": 0 },
  { "name": "Sunbed Reservation", "price": 0 },
  { "name": "Poolside Dining", "price": 0 },
  { "name": "Floating Breakfast", "price": 1200 },

  { "name": "Helipad Access", "price": 5000 },
  { "name": "Luxury Car Rental", "price": 8000 },
  { "name": "Chauffeur Service", "price": 3000 },
  { "name": "Yacht Charter", "price": 15000 },
  { "name": "Private Jet Coordination", "price": 50000 },

  { "name": "Wedding Planning", "price": 10000 },
  { "name": "Event Decor Services", "price": 5000 },
  { "name": "Banquet Hall Rental", "price": 8000 },
  { "name": "DJ & Entertainment Booking", "price": 7000 },
  { "name": "Photography & Videography", "price": 6000 },

  { "name": "VIP Lounge Access", "price": 0 },
  { "name": "Executive Club Benefits", "price": 0 },
  { "name": "Priority Check-In", "price": 0 },
  { "name": "Complimentary Upgrades", "price": 0 },
  { "name": "Late Night Snack Menu", "price": 400 },

  { "name": "Cultural Experience Booking", "price": 0 },
  { "name": "Cooking Class", "price": 1500 },
  { "name": "Language Assistance", "price": 0 },
  { "name": "Local Guide Service", "price": 2000 },
  { "name": "Heritage Walks", "price": 1000 },

  { "name": "Eco-Tourism Packages", "price": 2500 },
  { "name": "Organic Farm Visit", "price": 1200 },
  { "name": "Bird Watching Tour", "price": 1000 },
  { "name": "Nature Trail Guide", "price": 800 },
  { "name": "Star Gazing Setup", "price": 1500 },

  { "name": "Ayurvedic Consultation", "price": 1000 },
  { "name": "Detox Program", "price": 3000 },
  { "name": "Meditation Sessions", "price": 800 },
  { "name": "Sound Healing Therapy", "price": 1200 },
  { "name": "Aromatherapy", "price": 1000 },

  { "name": "Art Gallery Access", "price": 0 },
  { "name": "Live Music Evenings", "price": 0 },
  { "name": "Wine Tasting", "price": 2000 },
  { "name": "Mixology Workshop", "price": 1800 },
  { "name": "Craft Workshop", "price": 1000 },

  { "name": "Digital Detox Package", "price": 0 },
  { "name": "Sleep Therapy Program", "price": 2500 },
  { "name": "Forest Bathing Experience", "price": 1500 },
  { "name": "Mindfulness Retreat", "price": 3000 },
  { "name": "Wellness Concierge", "price": 0 },

                  ],

   
  });

  const [searchText, setSearchText] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  


  const [shopName, setShopName] = useState('');
  const [gstNumber, setGstNumber] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedItem, setSelectedItem] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [cart, setCart] = useState([]);
  const [gstRate, setGstRate] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showModal, setShowModal] = useState(false);

  const [shareMethod, setShareMethod] = useState('');
  const [pdfFormat, setPdfFormat] = useState('default');


  const handleSearchChange = (event) => {
    const text = event.target.value;
    setSearchText(text);
  
    const allItems = Object.entries(categories).flatMap(([category, items]) =>
      items.map(item => ({ ...item, category }))
    );
  
    const filtered = allItems.filter(item =>
      item.name.toLowerCase().includes(text.toLowerCase())
    );
  
    setSuggestions(filtered);
  };

  const handleSelectSuggestion = (item) => {
    const newItem = {
      name: item.name,
      price: item.price,
      quantity: 1,
      subtotal: item.price * 1,
    };
    setCart([...cart, newItem]);
    setSearchText('');
    setSuggestions([]);
  };

  const handleNewBill = () => {
    setShopName('');
    setGstNumber('');
    setPhoneNumber('');
    setSelectedCategory('');
    setSelectedItem('');
    setQuantity(1);
    setCart([]);
    setGstRate(0);
    setSearchText('');
    setSuggestions([]);
    setPdfFormat('default');
  };
  

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setSelectedItem('');
    setQuantity(1);
  };

  const handleItemChange = (event) => {
    setSelectedItem(event.target.value);
    setQuantity(1);
  };

  const handleQuantityChange = (event) => {
    setQuantity(event.target.value);
  };

  const handleAddItem = () => {
    const categoryItems = categories[selectedCategory];
    const item = categoryItems.find(i => i.name === selectedItem);
    if (item) {
      const newItem = {
        name: item.name,
        price: item.price,
        quantity: quantity,
        subtotal: item.price * quantity
      };
      setCart([...cart, newItem]);
      setSelectedItem('');
      setQuantity(1);
    }
  };

  const handleGstRateChange = (event) => {
    setGstRate(event.target.value);
  };

  const handlePriceChange = (index, event) => {
    const newCart = [...cart];
    newCart[index].price = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleQuantityEdit = (index, event) => {
    const newCart = [...cart];
    newCart[index].quantity = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleRemoveItem = (index) => {
    const newCart = [...cart];
    newCart.splice(index, 1); // Remove one item at the given index
    setCart(newCart);
  };
  
  const calculateTotal = () => {
    const subtotal = cart.reduce((acc, item) => acc + item.subtotal, 0);
    const gst = subtotal * (gstRate / 100);
    const total = subtotal + gst;
    return { subtotal, gst, total };
  };

  const generatePdfInvoice = () => {
    const total = calculateTotal();
    const currentDate = new Date().toLocaleDateString();
    const doc = new jsPDF();

    switch (pdfFormat) {
        case 'default':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'table':
            doc.autoTable({
                head: [[' Name', 'GST No', 'Phone Number', 'Date']],
                body: [[shopName, gstNumber, phoneNumber, currentDate]],
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'blueBlack':
            doc.setTextColor(0, 0, 255);
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.setTextColor(0, 0, 0);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'professionalGrid':
            doc.setFontSize(18);
            doc.text(shopName, 10, 10);
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 10, 20);
            doc.text(`Date: ${currentDate}`, 10, 30);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                theme: 'grid',
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                theme: 'grid',
            });
            break;

        case 'compactSummary':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

            
                case 'classicTable':
                    doc.setFontSize(20);
                    doc.text(shopName, 105, 15, null, null, 'center');
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
                    doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
                    doc.setFontSize(16);
                    doc.text('Invoice', 105, 30, null, null, 'center');
                    doc.autoTable({
                        startY: 40,
                        head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                        body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                    });
                    break;
        
                case 'boxedLayout':
                    doc.setFontSize(20);
                    doc.text(shopName, 10, 10);
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 10, 20);
                    doc.text(`Date: ${currentDate}`, 10, 30);
                    doc.autoTable({
                        startY: 40,
                        head: [['Item', 'Price', 'Quantity', 'Subtotal']],
                        body: cart.map((item) => [item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                        styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0], lineWidth: 0.5 },
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                        styles: { fillColor: [0, 180, 0], textColor: [0, 0, 0] },
                    });
            break;   
            
            

        case 'modernMinimalist':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            break;

        case 'elegantLines':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            break;

        case 'detailedSections':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Section', 'Details']],
                body: [
                    ['Shop Details', `${shopName}, GST No: ${gstNumber}, Date: ${currentDate}`],
                    ['Items', cart.map((item) => `Name: ${item.name}, Quantity: ${item.quantity}, Subtotal: ${item.subtotal.toFixed(2)}`).join('; ')],
                    ['Totals', `Subtotal: ${total.subtotal.toFixed(2)}, GST: ${total.gst.toFixed(2)}, Total: ${total.total.toFixed(2)}`],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.5 },
            });
            break;

        

        default:
            break;
    }

    // Save the PDF to Blob
    const pdfBlob = doc.output('blob');

    // Share to WhatsApp
    const shareToWhatsApp = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(whatsappUrl, '_blank');
    };

    // Share to Email
    const shareToEmail = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const mailtoUrl = `mailto:?subject=Your Invoice&body=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(mailtoUrl, '_blank');
    };

    // Share the PDF as needed
    if (shareMethod === 'whatsapp') {
        shareToWhatsApp();
    } else if (shareMethod === 'mail') {
        shareToEmail();
    }

    // Save the PDF
    //doc.save('invoice.pdf');
    doc.save(`${shopName +'-invoice' || 'invoice'}.pdf`);

};


  const handleShare = (method) => {
    setShareMethod(method); // Set the sharing method
    const shareText = `Shop Name: ${shopName}\nGST No: ${gstNumber}\nPhone Number: ${phoneNumber}`;

    if (method === 'whatsapp') {
      window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(shareText)}`);
    } else if (method === 'mail') {
      window.open(`mailto:?subject=MarketApp%20Details&body=${encodeURIComponent(shareText)}`);
    }

    setShowModal(false); // Close modal after sharing
  };

  const handleGenerateAndShare = () => {
    generatePdfInvoice();
    setShowModal(true); // Show modal after generating PDF
  };

  const handleFormatChange = (e) => {
    setPdfFormat(e.target.value); // Set the PDF format
};

const formatOptions = [
    { value: 'default', label: 'Default' },
    { value: 'table', label: 'Table Format' },
    { value: 'blueBlack', label: 'Blue and Black' },
    { value: 'professionalGrid', label: 'Professional Grid' },
    { value: 'compactSummary', label: 'Compact Summary' },
    { value: 'classicTable', label: 'Classic Table' },
    { value: 'boxedLayout', label: 'Boxed Layout' },
    { value: 'modernMinimalist', label: 'Modern Minimalist' },
    { value: 'elegantLines', label: 'Elegant Lines' },
    { value: 'detailedSections', label: 'Detailed Sections' },
    
];


return (
    <div className="MarketApp">
       <img src="./Images/jalm.png" alt="Just A Little Market" width="100" height="100" />
      <h1><u>Hotel/Restaurant/Fast Food</u></h1>

<div style={{ marginTop: '20px', textAlign: 'left', paddingLeft: '10px' }}>
  <button
    onClick={handleNewBill}
    style={{
      backgroundColor: '#007bff',
      color: '#fff',
      padding: '12px 20px',
      fontSize: '18px',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 123, 255, 0.3)',
      transition: 'background-color 0.3s ease, transform 0.2s ease'
    }}
    onMouseOver={(e) => {
      e.target.style.backgroundColor = '#0056b3';
      e.target.style.transform = 'scale(1.05)';
    }}
    onMouseOut={(e) => {
      e.target.style.backgroundColor = '#007bff';
      e.target.style.transform = 'scale(1)';
    }}
  >
    🧾 New Bill
  </button>
</div>
<br/>

  
      {/* Shop Info */}
  
    <div className="container">
  {/* Responsive Input Section */}
  <div className="input-section">
    <div className="form-group">
      <label>Store/Shop Name:</label>
      <input type="text" value={shopName} onChange={(e) => setShopName(e.target.value)} />
    </div>

    <div className="form-group">
      <label>GST No:</label>
      <input type="text" value={gstNumber} onChange={(e) => setGstNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Phone Number:</label>
      <input type="text" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Search Items:</label>
      <input
        type="text"
        value={searchText}
        onChange={handleSearchChange}
        placeholder="Type to search..."
      />
      {suggestions.length > 0 && (
        <ul className="suggestion-list">
          {suggestions.map((item, idx) => (
            <li key={idx} onClick={() => handleSelectSuggestion(item)}>
              {item.name} — ₹{item.price} <span className="category">({item.category})</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>

  {/* Category Selection */}
  <div className="form-group">
    <label>Select Category:</label>
    <select onChange={handleCategoryChange} value={selectedCategory}>
      <option value="" disabled>Select a category</option>
      {Object.keys(categories).map((cat, i) => (
        <option key={i} value={cat}>{cat}</option>
      ))}
    </select>
  </div>

  {selectedCategory && (
    <>
      <div className="form-group">
        <label>Select Item:</label>
        <select onChange={handleItemChange} value={selectedItem}>
          <option value="" disabled>Select an item</option>
          {categories[selectedCategory].map((item, i) => (
            <option key={i} value={item.name}>{item.name}</option>
          ))}
        </select>
      </div>

      {selectedItem && (
        <>
          <div className="form-group">
            <label>Quantity:</label>
            <input type="number" value={quantity} onChange={handleQuantityChange} min="1" />
          </div>
          <div className="form-group">
            <button onClick={handleAddItem}>Add Item</button>
          </div>
        </>
      )}
    </>
  )}

  {/* Cart Table */}
  <div className="cart-section">
    <h2>Cart</h2>
    {cart.length === 0 ? (
      <p>No items added.</p>
    ) : (
      <div className="responsive-table">
        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Price</th>
              <th>Qty</th>
              <th>Subtotal</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            {cart.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>
                  <input
                    type="number"
                    value={item.price}
                    onChange={(e) => handlePriceChange(index, e)}
                    min="0"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={item.quantity}
                    onChange={(e) => handleQuantityEdit(index, e)}
                    min="1"
                  />
                </td>
                <td>{item.subtotal.toFixed(2)}</td>
                <td><button onClick={() => handleRemoveItem(index)}>Remove</button></td>
              </tr>
            ))}
            <tr>
              <td colSpan="3">Subtotal</td>
              <td>{calculateTotal().subtotal.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">
                GST Rate:
                <select onChange={handleGstRateChange} value={gstRate}>
                  <option value="0">0%</option>
                    <option value="2.5">2.5%</option>
                  <option value="5">5%</option>
                  <option value="6">6%</option>
                  <option value="9">9%</option>
                  <option value="18">18%</option>
                </select>
              </td>
              <td>{calculateTotal().gst.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">Total</td>
              <td>{calculateTotal().total.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )}
  </div>

  {/* PDF Section */}
{cart.length > 0 && (
 
  <div className="pdf-section" style={{
    marginTop: '30px',
    padding: '20px',
    backgroundColor: '#f1f3f5',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  }}>
    <label style={{
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#333'
    }}>
      🧾 Select Invoice Format:
    </label>

    <select
      onChange={handleFormatChange}
      value={pdfFormat}
      style={{
        padding: '10px',
        fontSize: '16px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        width: '100%',
        boxSizing: 'border-box'
      }}
    >
      {formatOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>

    <button
      onClick={handleGenerateAndShare}
      style={{
        backgroundColor: '#007bff',
        color: '#fff',
        padding: '14px',
        fontSize: '17px',
        fontWeight: '600',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px rgba(0,123,255,0.3)',
        transition: 'transform 0.2s ease, background-color 0.3s ease'
      }}
      onMouseOver={(e) => {
        e.target.style.backgroundColor = '#0056b3';
        e.target.style.transform = 'scale(1.05)';
      }}
      onMouseOut={(e) => {
        e.target.style.backgroundColor = '#007bff';
        e.target.style.transform = 'scale(1)';
      }}
    >
      📄 Generate PDF Invoice
    </button>
  </div>
)}


<br /><br />

 

</div>

 </div>   
  ); // ✅ this closes the return statement
  
  
}

export default Hotel;
  


  

